import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

export interface AuthLayoutProps {
  actions?: ReactNode
  children: ReactNode
  cardClassName?: string
  portal: 'admin' | 'user'
}

export function AuthLayout({ actions, children, cardClassName, portal }: AuthLayoutProps) {
  return (
    <main className="auth-stage min-h-dvh overflow-x-clip bg-white px-4 text-[var(--color-text)]">
      {actions ? <div className="fixed right-6 top-6 z-20">{actions}</div> : null}
      {/* 登录页舞台保持单一文档流表面；出现内层纵向滚动条就是回归。 */}
      <section className="relative z-10 flex min-h-dvh items-center justify-center py-8">
        <div
          data-testid="auth-card"
          className={cn(
            'w-full max-w-[360px] rounded-[10px] border border-[var(--color-panel-border)] bg-white px-[38px] shadow-[0_2px_20px_4px_rgba(26,28,25,0.12)]',
            portal === 'user'
              ? 'min-h-[520px] translate-y-[37px] py-[50px]'
              : 'min-h-[460px] -translate-y-2 py-[56px]',
            cardClassName,
          )}
        >
          {children}
        </div>
      </section>
    </main>
  )
}
